import React from 'react';

const ExecutionVsBudgetChart = ({ data }) => {
  const formatCurrency = (value) => {
    return new Intl.NumberFormat('es-CO', {
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(value);
  };

  const executionPercentage = data ? (data.executed / data.budget) * 100 : 0;
  const remainingBudget = data ? data.budget - data.executed : 0;

  return (
    <div className="w-full h-full">
      <div className="chart-header">
        <h3 className="chart-title">Ejecución vs Presupuesto</h3>
        <p className="chart-subtitle">Nivel de cumplimiento presupuestal</p>
      </div>
      
      <div className="chart-content">
        {data ? (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-4">
              <div className="bg-gray-50 p-4 rounded">
                <h4 className="text-sm font-medium text-gray-600">Ejecutado</h4>
                <p className="text-2xl font-bold text-green-600">{formatCurrency(data.executed)}</p>
              </div>
              <div className="bg-gray-50 p-4 rounded">
                <h4 className="text-sm font-medium text-gray-600">Presupuesto</h4>
                <p className="text-2xl font-bold text-blue-600">{formatCurrency(data.budget)}</p>
              </div>
            </div>
            
            <div className="space-y-2">
              <div className="flex justify-between text-sm">
                <span>Ejecución</span>
                <span>{executionPercentage.toFixed(1)}%</span>
              </div>
              <div className="w-full bg-gray-200 rounded-full h-2">
                <div 
                  className="bg-orange-500 h-2 rounded-full transition-all duration-300"
                  style={{ width: `${Math.min(executionPercentage, 100)}%` }}
                />
              </div>
            </div>
          </div>
        ) : (
          <div className="flex items-center justify-center h-64 text-gray-500">
            <div className="text-center">
              <div className="text-4xl mb-2">📊</div>
              <p>No hay datos disponibles</p>
            </div>
          </div>
        )}
      </div>
      
      <div className="chart-footer">
        <div className="chart-insight">
          {remainingBudget > 0 ? 'Presupuesto disponible' : 'Presupuesto agotado'}
        </div>
        <div className="chart-metric">
          Disponible: {formatCurrency(remainingBudget)}
        </div>
      </div>
    </div>
  );
};

export default ExecutionVsBudgetChart; 